import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Container } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import CardStatusSection from 'components/CardStatusSection';
import { GET_CARD_NETWORK_STATUS } from 'components/CardStatusSection/CardStatusSection.queries';

import MerchantLoader from './components/MerchantLoader';

type Props = {
  classes: ClassProp<typeof styles>;
};

const styles = {
  header: {
    marginTop: '12.5rem !important',
  },
};

const Home: FunctionComponent<Props> = ({ classes }) => (
  <Container className={classes.header}>
    <CardStatusSection query={GET_CARD_NETWORK_STATUS} params={{}} />
    <MerchantLoader />
  </Container>
);

export default withStyles(styles)(Home);
